// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"415":"c88ac105","866":"c88ac105"}[chunkId] + ".chunk.css";
};